import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "@/lib/sentry";
import { reportWebVitals } from "@/lib/web-vitals";
import "./index.css";
import App from "./App";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

reportWebVitals();
